import React, { useState, useEffect } from "react";
import { Box, Typography, LinearProgress } from "@mui/material";
import { DotLottieReact } from '@lottiefiles/dotlottie-react';

const transitAnimations = `
  @keyframes signal {
    0% { opacity: 0.3; }
    50% { opacity: 1; }
    100% { opacity: 0.3; }
  }
`;

const Loader = () => {
  const [statusIndex, setStatusIndex] = useState(0);

  const statuses = [
    "LOADING DASHBOARD METRICS",
    "SYNCHRONIZING DATA STREAMS",
    "CALCULATING ANALYTICS",
    "OPTIMIZING ROUTE PATHWAY",
    "FINALIZING DISPLAY",
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setStatusIndex((prev) => (prev + 1) % statuses.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Box
      sx={{
        height: "90vh",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
      }}
    >
      <style>{transitAnimations}</style>

      {/* ===== LOTTIE ANIMATION ===== */}
      <Box sx={{ width: 300, height: 300, mb: 3 }}>
        <DotLottieReact
          src="https://lottie.host/c038644e-e079-482b-b764-fa0fabba7a40/6wZavXKrE8.lottie"
          loop
          autoplay
        />
      </Box>

      <Box sx={{ textAlign: "center", width: "100%", maxWidth: 300 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 1.5,
            mb: 2,
          }}
        >
          <Typography
            sx={{
              fontSize: 14,
              fontWeight: 900,
              letterSpacing: "3px",
              textTransform: "uppercase",
            }}
          >
            In Transit
          </Typography>
          <Box
            sx={{
              width: 6,
              height: 6,
              bgcolor: "#10B981",
              borderRadius: "50%",
              animation: "signal 1s infinite",
            }}
          />
        </Box>

        <LinearProgress
          sx={{
            height: 2,
            borderRadius: 1,
            bgcolor: "#E2E8F0",
            "& .MuiLinearProgress-bar": {
              bgcolor: "primary.main",
            },
            mb: 2,
          }}
        />

        <Typography
          sx={{
            fontSize: 10,
            color: "text.secondary",
            fontWeight: 700,
            letterSpacing: "1px",
          }}
        >
          {statuses[statusIndex]}
        </Typography>
      </Box>

      <Box
        sx={{
          position: "absolute",
          top: 20,
          right: 20,
          opacity: 0.1,
          fontFamily: "monospace",
          fontSize: "12px",
          fontWeight: "bold",
          textAlign: "right",
        }}
      >
        SYS_ID: 4829
        <br />
        STATUS: ACTIVE
      </Box>
    </Box>
  );
};

export default Loader;
